import { PhoneOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';

import s from './Phone.module.less';

interface Props {
  value: string;
  'data-testid'?: string;
}

export const Phone = observer<Props>(({ value, 'data-testid': DTI }) => {
  const cleanValue = value.match(/\d|\+/g)?.join('');

  return (
    <Typography.Link href={`tel:${cleanValue}`} className={s.phone} data-testid={DTI} data-testvalue={value}>
      <PhoneOutlined className={s.phoneIcon} />
      <span>{value}</span>
    </Typography.Link>
  );
});
